import Controller from "./reservation.controller";
import template from "./reservation.html";

const reservation = {
  template,
  controller: Controller,
};

export default reservation;



// WEBPACK FOOTER //
// ./src/pages/reservation/reservation.component.js